import { render, staticRenderFns } from "./UvozKretanjaVozila.vue?vue&type=template&id=08213baf&scoped=true&"
import script from "./UvozKretanjaVozila.vue?vue&type=script&lang=ts&"
export * from "./UvozKretanjaVozila.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08213baf",
  null
  
)

export default component.exports